import {Injectable} from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {FlightSchedule} from '../../interfaces/FlightSchedule';

@Injectable()
export class FlightScheduleService {

  private route = 'contract';

  constructor(private http: AuthHttp) {}
  public getFlightSchedules(contractId: number): Promise<FlightSchedule[]> {
    return this.http.get(`${environment.baseUrl}${this.route}/${contractId}/flight-schedule`).map((res) => res.json()).toPromise();
  }

  public upsert(flightSchedule: FlightSchedule) {
    return this.http.put(`${environment.baseUrl}${this.route}/${flightSchedule.contract_id}/flight-schedule`, flightSchedule)
      .map((res) => res.json()).toPromise();
  }

  public delete(flightSchedule: FlightSchedule) {
    return this.http.delete(`${environment.baseUrl}${this.route}/${flightSchedule.contract_id}/flight-schedule/${flightSchedule.id}`)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/contract/services/flight-schedule-service/flight-schedule.service.ts